var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchInterfaceSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.657,
    height: 24.657,
    viewBox: "0 0 24.657 24.657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-interface-symbol",
    transform: "translate(-0.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x34__4_",
    transform: "translate(0.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25841",
    "data-name": "Group 25841",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25222",
    "data-name": "Path 25222",
    d: "M24.429,23.316l-6.366-6.264a10.069,10.069,0,0,0,2.691-6.842A10.293,10.293,0,0,0,10.38,0,10.292,10.292,0,0,0,.006,10.209,10.292,10.292,0,0,0,10.38,20.418a10.433,10.433,0,0,0,6.53-2.28L23.3,24.427a.807.807,0,0,0,1.128,0A.777.777,0,0,0,24.429,23.316ZM10.38,18.847A8.709,8.709,0,0,1,1.6,10.209,8.709,8.709,0,0,1,10.38,1.571a8.709,8.709,0,0,1,8.778,8.638A8.709,8.709,0,0,1,10.38,18.847Z",
    transform: "translate(-0.006)",
    fill: "#200e32"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchInterfaceSymbol);
export default __webpack_public_path__ + "static/media/search-interface-symbol.92f96ee1a7856aaa5e2d67bb23298891.svg";
export { ForwardRef as ReactComponent };